import TabPanel from "@mui/lab/TabPanel";
import { Divider, Tab } from "@mui/material";
import TabContext from "@mui/lab/TabContext";
import { Box, Tabs } from "@mui/material";
import Charts from "./Charts";
import Pricing from "./Pricing";
import Operations from "./Operations";
import React from "react";


export default function PerformanceReview({ customer_id, height }: { customer_id: number, height: number }) {
    const [value, setValue] = React.useState('0');
    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
        setValue(newValue);
    };


    return (
        <Box sx={{ width: '100%', typography: 'body1', height: 'auto', margin: '-25px 0 0 0', padding: 0, backgroundColor: 'white', borderRadius: '6px !important' }}>
            <TabContext value={value}>
                <Box>
                    <Tabs 
                        variant="scrollable"
                        scrollButtons
                        allowScrollButtonsMobile
                        selectionFollowsFocus
                        onChange={handleChange} 
                        aria-label="lab API tabs example" 
                        value={value}
                    >
                        <Tab wrapped style={{ textTransform: 'capitalize' }} label="Revenues" value="0" />
                        <Tab wrapped style={{ textTransform: 'capitalize' }} label="Operations" value="1" />
                        <Tab wrapped style={{ textTransform: 'capitalize' }} label="Pricing" value="2" />
                        {/* <Tab wrapped style={{ textTransform: 'capitalize' }} label="Trends" value="3" /> */}
                    </Tabs>
                </Box>
                <Divider />
                <TabPanel value={'0'}>
                    <Charts value={Number(value)} id={Number(customer_id)} height={height} />
                </TabPanel>
                <TabPanel value={'1'}>
                    <Operations id={Number(customer_id)} height={height} />
                </TabPanel>
                <TabPanel value={'2'}>  
                    <Pricing id={Number(customer_id)} height={height} />
                </TabPanel>
            </TabContext>
        </Box>
    );
}